module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/restaurants_3-d913a13dbcb590fea3a7b97432e9bafa.jpg";